export default __webpack_public_path__ + "static/media/330_portfolio03-es-web.9bd5f330.png";